import { render, staticRenderFns } from "./AnalyticsMainPage.vue?vue&type=template&id=25af6ab8&scoped=true"
import script from "./AnalyticsMainPage.vue?vue&type=script&lang=js"
export * from "./AnalyticsMainPage.vue?vue&type=script&lang=js"
import style0 from "./AnalyticsMainPage.vue?vue&type=style&index=0&id=25af6ab8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25af6ab8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VProgressCircular,VTabItem,VTabsItems})
